import { useFeatureFlags, useFeatureFlagsWithPrefs } from '@fs/zion-flags'
import React, { createContext, useContext, useMemo } from 'react'
import { FLAGS, flagsConfig } from '../../config'

const FlagsContext = createContext()
export const useFlagsContext = () => useContext(FlagsContext)

export const RootstechFlagsProvider = ({ children }) => {
  const { labsPref, flagsWithPrefs, flagsWithoutPrefs } = flagsConfig
  const prefs = flagsWithPrefs.map(() => labsPref)
  const { data: featureFlagsWithPrefs, loading: featureFlagsWithPrefsLoading } = useFeatureFlagsWithPrefs(
    flagsWithPrefs,
    null,
    { userPreferences: prefs }
  )
  const featureFlags = useFeatureFlags(flagsWithoutPrefs)

  const combinedFlags = useMemo(
    () => ({ ...featureFlagsWithPrefs, ...featureFlags }),
    [featureFlagsWithPrefs, featureFlags]
  )
  // if the prefs flags are undefined (such as if it is loading), send an empty object to prevent type errors
  if (!featureFlagsWithPrefs) {
    flagsWithPrefs.forEach((flag) => {
      combinedFlags[flag] = {}
    })
  }

  // make sure every flag is there and defined
  const missingFlags = Object.values(FLAGS).filter((flagName) => !combinedFlags[flagName])
  try {
    if (missingFlags.length) {
      throw new Error('Missing flags')
    }
  } catch (e) {
    console.error(e, missingFlags)
    // stub out any missing flags
    missingFlags.forEach((flag) => {
      combinedFlags[flag] = {}
    })
  }

  const value = useMemo(
    () => ({ ...combinedFlags, loading: featureFlagsWithPrefsLoading }),
    [combinedFlags, featureFlagsWithPrefsLoading]
  )

  return <FlagsContext.Provider value={value}>{children}</FlagsContext.Provider>
}
